// moonGenerator.js
var MoonGenerator = pc.createScript('moonGenerator');

MoonGenerator.attributes.add('moonEnts', {type:'entity', array:true});
MoonGenerator.attributes.add('mtBase', {type:'asset', assetType: "material", array:true});
MoonGenerator.attributes.add('mtCaps', {type:'asset', assetType: "material", array:true});
MoonGenerator.attributes.add('posRange',{type:'vec2'});
MoonGenerator.attributes.add('scaleRange',{type:'vec2'});
MoonGenerator.attributes.add('rotationRange',{type:'vec2'});
MoonGenerator.attributes.add('standAlone', {type:'boolean', default:false});
MoonGenerator.attributes.add('factor', {type:'number', default:50});
MoonGenerator.attributes.add('civMats', {type:'asset', assetType:'material', array:true});
MoonGenerator.attributes.add('moonProb', {type:'number', title:'MoonPropability', default:5});


// initialize code called once per entity
MoonGenerator.prototype.initialize = function() {

    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.randomize = 0.0;
    this.theSeed = this.seedScript.seed;
    this.count = 0;
    this.ind = 0;
    
};

MoonGenerator.prototype.go = function() {

    this.theSeed = this.seedScript.seed + this.ind;
        
    this.randomize = new Math.seedrandom(this.theSeed);
    this.rndSize = Math.floor(this.randomize()*10);
    
    for(var cnt = 0; cnt < this.moonEnts.length; cnt++){
        
        if(this.randomize() < this.moonProb/10){
            this.count += 1;
            this.moonEnts[cnt].enabled = true;
            var rndPos = this.randomize() * (this.posRange.y - this.posRange.x) + (this.posRange.x);
            this.moonEnts[cnt].children[0].setLocalPosition(0,0,rndPos);
            if(this.moonEnts[cnt].children[1]){
                this.moonEnts[cnt].children[1].setLocalPosition(0,0,rndPos);
                this.moonEnts[cnt].children[2].setLocalPosition(0,0,rndPos);
            }
            var rndScle = this.randomize() * (this.scaleRange.y - this.scaleRange.x) + this.scaleRange.x;
            //console.log('rndSclx: '  + this.scaleRange.x+ ' rndScly: ' + this.scaleRange.y + ' rndScl: ' +  rndScle);
            this.moonEnts[cnt].children[0].setLocalScale(rndScle, rndScle, rndScle);
            var rndRotY = Math.floor(this.randomize()*360);
            var rndRotX = this.randomize()*15;
            if(this.randomize()>0.5){
                rndRotX *= -1;
            }
            this.moonEnts[cnt].setLocalEulerAngles(rndRotX, rndRotY, 0);
            var me = this.moonEnts[cnt].children[0].model.model.meshInstances[0];
            var mBs = this.mtBase[Math.floor(this.randomize()*this.mtBase.length)];
            me.material = mBs.resource;

            if(this.moonEnts[cnt].children[0].children[0].name == 'hemisphere'){
                var cntnr = this.app.root.findByName('container');
                var ce = this.moonEnts[cnt].children[0].children[0].model.model.meshInstances[0];
                var cMat = this.civMats[Math.floor(this.randomize()*this.civMats.length)];
                this.moonEnts[cnt].children[0].children[0].lookAt(0,0,0);
              //  console.log(cMat);
                ce.material = cMat.resource;
            }
            
        } else {
            this.moonEnts[cnt].enabled = false;
        }
    }
    this.count = 0;
    this.ind = 0;
};

// update code called every frame
MoonGenerator.prototype.update = function(dt) {
    // if(this.standAlone){    
    //     if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {
    //        // console.log('KEYPRESSED');
    //         this.start();
    //     }
    // }
};

// swap method called for script hot-reloading
// inherit your script state here
// MoonGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

